import { __assign } from "tslib";
import { connect } from 'react-redux';
import { getIsLoggedIn, getWatchCount, getCartCount, getFeedbackCount, getNotesCount, getDywHasNew, getIsEclipseSwitcherEnabled, getVerificationEmailAddress, getCoreLevel, getCurrentUserHasWixPortfolio, getCanUserSeeWatch, } from '../publicSession/selectors';
import { getChatUnreadCount } from '../ChatV2/redux/selectors';
import { siteHeaderSearchButtonClicked, userLogoutButtonClicked, openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, toggleNotificationsDropdown, toggleSubmitMenu, openSearchModal, closeSearchModal, toggleSearchModal, hidePortfolioTooltip, deletePortfolio, } from './redux/actions';
import { switchVersion } from '../publicSession/actions';
import { getSiteHeaderState } from './redux/selectors';
import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
import { FirstTimeFlag, hasFirstTimeFlag, dropFirstTimeFlagSimple, } from '../redux/firstTimeFlags';
function mapStateToProps(state) {
    return __assign({ isLoggedIn: getIsLoggedIn(state), watchCount: getWatchCount(state), cartCount: getCartCount(state), chatCount: getChatUnreadCount(state), feedbackCount: getFeedbackCount(state), noteCount: getNotesCount(state), disableVersionSwitcher: !getIsEclipseSwitcherEnabled(state), hasWixPortfolio: !getCurrentUserHasWixPortfolio(state), verificationEmail: getVerificationEmailAddress(state), canSeeOldWatch: getCanUserSeeWatch(state), coreLevel: getCoreLevel(state), dywHasNewContent: getDywHasNew(state), moreMenuHasNewContent: hasFirstTimeFlag(state, FirstTimeFlag.IsArtShopInSiteHeaderNotSeen) }, getSiteHeaderState(state));
}
var mapDispatchToProps = {
    onSiteHeaderSearchButtonClicked: siteHeaderSearchButtonClicked,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
    switchVersion: switchVersion,
    openUserDropdown: openUserDropdown,
    closeUserDropdown: closeUserDropdown,
    openNotificationsDropdown: openNotificationsDropdown,
    closeNotificationsDropdown: closeNotificationsDropdown,
    toggleNotificationsDropdown: toggleNotificationsDropdown,
    toggleSubmitMenu: toggleSubmitMenu,
    openSearchModal: openSearchModal,
    closeSearchModal: closeSearchModal,
    toggleSearchModal: toggleSearchModal,
    hidePortfolioTooltip: hidePortfolioTooltip,
    deletePortfolio: deletePortfolio,
    pushChatModal: function () {
        return pushModal(ModalType.MOBILE_CHAT_LIST, { wrapInModal: false });
    },
    markMoreMenuSeen: function () {
        return dropFirstTimeFlagSimple(FirstTimeFlag.IsArtShopInSiteHeaderNotSeen);
    },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeader.container.js.map